import { render, staticRenderFns } from "./Servico.vue?vue&type=template&id=155d116c&"
import script from "./Servico.vue?vue&type=script&lang=js&"
export * from "./Servico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports